import React from "react";
import styled from "styled-components";

import Xarrow from "react-xarrows";
import { OpenBlueIcon } from "../../CommonUI/Icon/OpenBlueIcon";
import { MappingConstants } from "../../rule-engine-core/Mapping/MappingConstants";
import { useDrag } from "react-dnd";
import { MappingRule } from "../../rule-engine-core/Mapping/MappingConfiguration";

const portal: HTMLElement = document.createElement("div");
portal.classList.add("my-super-cool-portal");

if (!document.body) {
    throw new Error("body not ready for portal creation!");
}

document.body.appendChild(portal);

export const DragConnector = ({
    fromId,
    toId,
    icon,
    direction: propdirection,
    lineColor,
    lineWidth,
    mappingRule,
}: {
    fromId: string;
    toId: string;
    icon?: JSX.Element;
    direction?: "left" | "right" | "top" | "bottom";
    isDraggingDisabled?: boolean;
    lineColor?: string;
    lineWidth?: number;
    mappingRule: MappingRule;
}) => {
    const [{ isDragging }, drag] = useDrag({
        type: "field",
        item: { type: "rule", rule: mappingRule },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });

    let direction = propdirection || "right";

    if (isDragging) {
    } else {
    }

    return (
        <DragConnectorRender
            id={toId}
            ref={drag}
            direction={direction}
        >
            <div className={`${isDragging ? "drag-connector isdragging" : "drag-connector"}`}>
                {icon || <OpenBlueIcon />}
            </div>

            {direction === "right" && (
                <Xarrow
                    end={toId}
                    start={fromId}
                    startAnchor="right"
                    endAnchor="left"
                    color={lineColor || MappingConstants.MAPPING_LINE_COLOR}
                    strokeWidth={lineWidth || 10}
                    showHead={false}
                />
            )}
            {direction === "left" && (
                <Xarrow
                    end={fromId}
                    start={toId}
                    startAnchor="left"
                    endAnchor="right"
                    color={lineColor || MappingConstants.MAPPING_LINE_COLOR}
                    strokeWidth={lineWidth || 1}
                    showHead={false}
                />
            )}
        </DragConnectorRender>
    );
};

export const DragConnectorRender = styled.div<{ direction: "right" | "left" | "top" | "bottom" }>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 8px;
    height: 8px;

    position: absolute;

    ${(props) =>
        props.direction === "right" &&
        `
            left: 100%;
            top: 50%;
        `}

    ${(props) =>
        props.direction === "left" &&
        `
            right: 100%;
            top: 50%;
        `}

  transform: translateY(-50%);

    .drag-connector {
        display: flex;
    }
`;
